module.exports = __webpack_public_path__ + "static/media/icon_09.7dfc77e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_09.png
// module id = 1650
// module chunks = 1